/**
 * Store-wide Flash Deals add-to-cart gate (Phase 1).
 * Intercepts POST /cart/add.js — unlock KD 7 normal subtotal, max 3 flash units.
 */
(function () {
  var configEl = document.getElementById('flash-deals-config');
  if (!configEl) {
    return;
  }

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.warn('Flash Deals gate: invalid config', e);
    return;
  }

  if (config.enabled === false) {
    return;
  }

  var THRESHOLD_SUBUNITS = (config.thresholdKd || 7) * (config.priceDivisor || 100);
  var MAX_FLASH_ITEMS = config.maxFlashItems || 1;
  var CURRENCY = config.currency || 'KD';
  var FLASH_PRODUCT_IDS = (config.flashProductIds || []).map(String);
  var FLASH_VARIANT_IDS = (config.flashVariantIds || []).map(String);
  var cartFetchPromise = null;

  function isArabic() {
    return document.documentElement.lang && document.documentElement.lang.toLowerCase().indexOf('ar') === 0;
  }

  function formatKD(amountKd) {
    var ensure = window.SinbadMoneyDisplay && window.SinbadMoneyDisplay.ensureThreeDecimals;
    var str = ensure ? ensure(String(amountKd)) : String(amountKd);
    return isArabic() ? str + ' د.ك' : 'KD ' + str;
  }

  function subunitsToKd(subunits) {
    return (subunits || 0) / (config.priceDivisor || 100);
  }

  function isFlashLineItem(item) {
    if (!item) {
      return false;
    }

    if (item.variant_id != null && FLASH_VARIANT_IDS.indexOf(String(item.variant_id)) !== -1) {
      return true;
    }

    if (item.properties) {
      if (item.properties._flash_deal === '1' || item.properties._flash_deal === true) {
        return true;
      }
      if (item.properties.flash_deal === '1' || item.properties.flash_deal === true) {
        return true;
      }
    }

    if (item.product_id != null && FLASH_PRODUCT_IDS.indexOf(String(item.product_id)) !== -1) {
      return true;
    }

    if (item.handle && config.flashProductHandles && config.flashProductHandles.indexOf(item.handle) !== -1) {
      return true;
    }

    return false;
  }

  function isFlashVariant(variantId) {
    if (variantId == null || variantId === '') {
      return false;
    }
    return FLASH_VARIANT_IDS.indexOf(String(variantId)) !== -1;
  }

  function computeCartState(cart) {
    var normalSubtotalSubunits = 0;
    var flashQty = 0;

    (cart.items || []).forEach(function (item) {
      var lineSubunits = item.final_line_price != null ? item.final_line_price : item.line_price;

      if (isFlashLineItem(item)) {
        flashQty += item.quantity || 0;
      } else {
        normalSubtotalSubunits += lineSubunits || 0;
      }
    });

    var remainingSubunits = Math.max(THRESHOLD_SUBUNITS - normalSubtotalSubunits, 0);
    var unlocked = normalSubtotalSubunits >= THRESHOLD_SUBUNITS;
    var progressPercent = THRESHOLD_SUBUNITS > 0
      ? Math.min(100, (normalSubtotalSubunits / THRESHOLD_SUBUNITS) * 100)
      : 0;

    return {
      normalSubtotalSubunits: normalSubtotalSubunits,
      flashQty: flashQty,
      remainingSubunits: remainingSubunits,
      unlocked: unlocked,
      progressPercent: progressPercent
    };
  }

  function lockedGateMessage(state) {
    if (state && state.remainingSubunits > 0) {
      var remainingKd = subunitsToKd(state.remainingSubunits);
      return isArabic()
        ? 'أضف ' + formatKD(remainingKd) + ' من المنتجات العادية لفتح عروض الفلاش'
        : 'Add ' + formatKD(remainingKd) + ' of regular items to unlock Flash Deals';
    }

    return isArabic()
      ? 'أضف 7.000 د.ك من المنتجات العادية لفتح عروض الفلاش'
      : 'Add KD 7.000 of regular items to unlock Flash Deals';
  }

  function maxFlashGateMessage() {
    return isArabic()
      ? 'الحد الأقصى 1 منتجات فلاش لكل طلب'
      : 'Maximum 1 Flash Deal items per order';
  }

  function fetchCart() {
    if (!cartFetchPromise) {
      cartFetchPromise = fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .finally(function () {
          cartFetchPromise = null;
        });
    }
    return cartFetchPromise;
  }

  function dispatchStateUpdated(state, cart) {
    document.dispatchEvent(new CustomEvent('flash-deals:state-updated', {
      detail: { state: state, cart: cart }
    }));
  }

  function refreshCartState() {
    return fetchCart().then(function (cart) {
      var state = computeCartState(cart);
      dispatchStateUpdated(state, cart);
      return state;
    });
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') {
      return input;
    }
    if (input && typeof input.url === 'string') {
      return input.url;
    }
    return '';
  }

  function isCartAddRequest(url, method) {
    if ((method || 'GET').toUpperCase() !== 'POST') {
      return false;
    }
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function isCartMutationRequest(url, method) {
    if ((method || 'GET').toUpperCase() !== 'POST') {
      return false;
    }
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  function parseFlashAddsFromBody(body) {
    if (body == null) {
      return null;
    }

    var flashAdds = [];

    function addFlashLine(variantId, quantity) {
      if (!isFlashVariant(variantId)) {
        return;
      }
      flashAdds.push({
        variantId: String(variantId),
        quantity: Math.max(1, parseInt(quantity, 10) || 1)
      });
    }

    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (trimmed.charAt(0) === '{') {
        try {
          var jsonBody = JSON.parse(trimmed);
          if (jsonBody.items && jsonBody.items.length) {
            jsonBody.items.forEach(function (item) {
              if (item && item.id != null) {
                addFlashLine(item.id, item.quantity);
              }
            });
          } else if (jsonBody.id != null) {
            addFlashLine(jsonBody.id, jsonBody.quantity);
          }
        } catch (parseErr) {
          return null;
        }
      } else {
        var params = new URLSearchParams(body);
        if (params.has('items')) {
          try {
            var items = JSON.parse(params.get('items'));
            if (Array.isArray(items)) {
              items.forEach(function (item) {
                if (item && item.id != null) {
                  addFlashLine(item.id, item.quantity);
                }
              });
            }
          } catch (itemsErr) {
            return null;
          }
        } else if (params.has('id')) {
          addFlashLine(params.get('id'), params.get('quantity'));
        }
      }
    } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.has('id')) {
        addFlashLine(body.get('id'), body.get('quantity'));
      }
    }

    if (!flashAdds.length) {
      return null;
    }

    var totalFlashQty = 0;
    flashAdds.forEach(function (line) {
      totalFlashQty += line.quantity;
    });

    return {
      lines: flashAdds,
      totalFlashQty: totalFlashQty
    };
  }

  function blockedAddResponse(message) {
    document.dispatchEvent(new CustomEvent('flash-deals:blocked', {
      detail: { message: message }
    }));

    return Promise.resolve(new Response(JSON.stringify({
      status: 422,
      description: message
    }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' }
    }));
  }

  function validateFlashAdd(totalFlashQty) {
    return fetchCart().then(function (cart) {
      var state = computeCartState(cart);
      dispatchStateUpdated(state, cart);

      if (!state.unlocked) {
        return { blocked: true, message: lockedGateMessage(state), state: state };
      }

      if (state.flashQty + totalFlashQty > MAX_FLASH_ITEMS) {
        return { blocked: true, message: maxFlashGateMessage(), state: state };
      }

      return { blocked: false, state: state };
    });
  }

  window.FlashDealsGate = {
    config: config,
    isFlashVariant: isFlashVariant,
    isFlashLineItem: isFlashLineItem,
    computeCartState: computeCartState,
    refreshCartState: refreshCartState,
    lockedGateMessage: lockedGateMessage,
    maxFlashGateMessage: maxFlashGateMessage
  };

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    init = init || {};
    var url = getRequestUrl(input);
    var method = (init.method || 'GET').toUpperCase();

    if (isCartAddRequest(url, method)) {
      var flashAdds = parseFlashAddsFromBody(init.body);

      if (flashAdds) {
        return validateFlashAdd(flashAdds.totalFlashQty).then(function (result) {
          if (result.blocked) {
            return blockedAddResponse(result.message);
          }
          return originalFetch(input, init).then(function (response) {
            setTimeout(refreshCartState, 0);
            return response;
          });
        });
      }
    }

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartMutationRequest(url, method)) {
        setTimeout(refreshCartState, 0);
      }
      return response;
    });
  };

  refreshCartState();
})();
